/**
 * 전화번호 형식 변환
 * @note 숫자 string 형식을 '010-1234-5678' 형식으로 변환 (02 로 시작하는 경우 '02-1234-5678' 형식으로 변환)
 * @note 마스킹된 전화번호('0101234****')도 '010-1234-****' 형식으로 변환
 * @param tel 전화번호 string 형식
 * @returns 변환된 전화번호 string 형식
 */
const formatTel = (tel: string) => {
  if (!tel || tel.trim() === '') return '';

  const cleanTel = tel.replace(/[^\d*]/g, '');

  if (cleanTel === '') return '';

  if (cleanTel.startsWith('02')) {
    return cleanTel.replace(/(\d{2})([\d*]{3,4})([\d*]{4})/, '$1-$2-$3');
  }

  return cleanTel.replace(/([\d*]{3})([\d*]{3,4})([\d*]{4})/, '$1-$2-$3');
};

export default formatTel;
